module.exports = __webpack_public_path__ + "media/images/features/wedding-ceremony-cost/bycost-image-100000-102163570876b4f7670e6c69a6013875.png";